
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { NavigationService } from '../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { SharedService } from '../../../providers/shared.service';
import { DeactivateBusinessComponent } from '../../businesses/deactivate-business/deactivate-business.component';
import { threadId } from 'worker_threads';
import { StorageService } from '../../../providers/storage.service';
@Component({
  selector: 'sm-entity-business',
  templateUrl: './entity-business.component.html',
  styleUrls: ['./entity-business.component.scss']
})
export class EntityBusinessComponent implements OnInit {
  messageList: any[] = [];
  dislayHeader:string=''
  accountHashId: string= ''
  public loader: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "business name",
      columnProperty: "entityName"
    },
    {
      columnName: "address",
      columnProperty: "addressInfo"
    },
    {
      columnName: "date of joining",
      columnProperty: "senderPhone"
    },
    
    
    {
      columnName: "status",
      columnProperty: "isActive"
    },
  ];
  private _apiSubscription: Subscription;
  clickEventSubscription: Subscription;
  constructor(private _storageService: StorageService,private sharedService: SharedService, private _apiService: ApiService,private dialog: MatDialog, private _navService: NavigationService, private router: Router, private route: ActivatedRoute) { 
    this._navService.hideSidebarAndNav = false;
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_BUSINESS_LIST_RESULT){
        console.log(resData);
        this.messageList = resData.result ? resData.result : [];
        console.log( this.messageList);
        this.messageList.forEach((item )=> {
          if(item.addressInfo && item.addressInfo!= null){
            item.addressInfo = (JSON.parse(item.addressInfo)).address_line
          }
          if(item.isActive == '2' ||item.isActive == '3' ){
            item.isActive = 'Deleted'
          }
          if(item.isActive == '1'){
            item.isActive = 'Active'
          }
          if(item.isActive == '0'){
            item.isActive = 'Deactive'
          }
         
        })
            console.log( this.messageList);
        
      }
      this.loader = false;
    });
    // this.loader = false;
  }

  ngOnInit(): void {
    this.loader =true
    this.accountHashId = this._storageService.getValueFromAppStorage('specificEntityHash')
    this.dislayHeader = this._storageService.getValueFromAppStorage('specificEntityName') + ' > Businesses'
    // this.route.queryParams.subscribe(data => {
    //   console.log(data.accountHash);
    //   this.accountHashId = data.accountHash
    //   this.dislayHeader = data.name + ' > Businesses'
      
    // })
    this._apiService.getBusinessList(this.accountHashId);
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  // test(row:any){
  //   console.log(row);
    
  // }
  viewDocs(entityHash: string){
  console.log("clicked");
  this.router.navigate(['documents'], {relativeTo: this.route,queryParams: {'entityHash' : entityHash}})
}

viewDetails(entityHash: string){
  console.log(entityHash);
  this.router.navigate(['details'], {relativeTo: this.route,queryParams: {'entityHash' : entityHash}})
  
}
viewOnlinePayments(entityHash: string){
  console.log(entityHash);
  this.router.navigate(['onlinePayments'], {relativeTo: this.route, queryParams: {'entityHash' : entityHash}})
}
viewServices(entityHash: string){
// console.log(entityHash);
this.router.navigate(['services'], {relativeTo: this.route,queryParams: {'entityHash' : entityHash}})
}

viewEmployees(entityHash: string){
  this.router.navigate(['employees'], {relativeTo: this.route,queryParams: {'entityHash' : entityHash}})

}

viewBookings(entityHash: string){
  this.router.navigate(['bookings'], {relativeTo: this.route,queryParams: {'entityHash' : entityHash}})

}

deactivate(rowvalue:any) {
  console.log(rowvalue);

  // let metadata = {
  //   entityInfo: {
  //     hashId: rowvalue.hashId,
  //     entityStatus: 0
  //   }
  // }
// console.log(metadata);

  // this._apiService.updateEntityInfo(metadata)
  // setTimeout(() => {
  //   this.ngOnInit()
  // }, 1500);
  this.dialog.open(DeactivateBusinessComponent, {
    height: '350px',
    disableClose: true,
    data: {
      ref: this.dialog,
      data:rowvalue.hashId
    }
  });
}

activate(rowvalue:any){
  console.log(rowvalue);

  let metadata = {
    entityInfo: {
      hashId: rowvalue.hashId,
      entityStatus: 1
    }
  }
console.log(metadata);

  this._apiService.updateEntityInfo(metadata)
  setTimeout(() => {
    this.ngOnInit()
  }, 1500);
}
}
